<template>
  <pie-chart :chart-data="chartData"/>
</template>

<script>
  import PieChart from "@view/components/chart/PieChart"
  export default {
    name: "ShopType",
    components: {PieChart},
    data() {
      return {
        chartData: {
          title: "商家类型",
          roseType: false,
          radius: [0, 95],
          data: []
        }
      }
    },
    created() {
      this.getData();
    },
    methods: {
      async getData() {
        let p1 = this.$Http.getShopTypeStat;
        let p2 = this.$Http.getShopType;
        let [res1, res2] = await Promise.all([p1(), p2()]);
        if (res1?.data && res2.data) {
          let type = res2.data.list || {};
          let list = res1.data || [];
          this.chartData.data = list.map(item => {return {name: type[item.type], value: item.count}});
        }
      }
    }
  }
</script>

<style scoped>

</style>
